var _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoalgasFrontwheels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 73,
    viewBox: "0 0 286 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.6907,
    cy: 36.3196,
    r: 32.0229,
    fill: "black",
    stroke: "#DDDDDD",
    strokeWidth: 8.53945
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.6673,
    cy: 36.3196,
    r: 32.0229,
    fill: "black",
    stroke: "#DDDDDD",
    strokeWidth: 8.53945
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.636,
    cy: 36.3196,
    r: 32.0229,
    fill: "black",
    stroke: "#DDDDDD",
    strokeWidth: 8.53945
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.613,
    cy: 36.3196,
    r: 32.0229,
    fill: "black",
    stroke: "#DDDDDD",
    strokeWidth: 8.53945
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoalgasFrontwheels);
export default __webpack_public_path__ + "static/media/coalgas-frontwheels.2ed097ffd0da651f0f2075a30a342911.svg";
export { ForwardRef as ReactComponent };